import request from './requesters/client.request';

const pappersService = {
  /* eslint-disable-next-line */
  pappersSearchListCompany: (params: any) => request.get('/pappers-search-list-company', { params }),
  /* eslint-disable-next-line */
  pappersGetCompanyDetail: (params: any) => request.get('/pappers-get-company-detail', { params }),
};

export default pappersService;
